<template>
  <app-report>
    <app-widget
      flat
      class-widget="md6 offset-md3 sm8 offset-sm2 xs12"
    >
      <div slot="widget-content">
        <app-report-header
          :title="cliente.nome"
        />
        <app-line-chart
          v-if="openChart"
          scale-label-x="Visita"
          scale-attribute="visita_data"
          dataset-label="Custo da alimentação concentrada"
          dataset-attribute="lactacao_custo_alimentacao_concentrada"
        />
        <v-simple-table :dense="tableDense">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Data visita
                </th>
                <th class="text-center">
                  Cliente
                </th>
                <th class="text-center">
                  Cidade/estado
                </th>
                <th class="text-center">
                  Custo
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="d-print-table-row"
                v-for="item in relatorio"
                :key="item.id"
              >
                <td
                  v-text="$options.filters.date(item.visita_data)"
                />
                <td
                  class="text-center"
                  v-text="item.cliente_nome"
                />
                <td
                  class="text-center"
                  v-text="`${item.cidade_nome}/${item.estado_acronimo}`"
                />
                <td
                  class="text-center"
                  v-text="$options.filters.currency(item.lactacao_custo_alimentacao_concentrada)"
                />
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </app-widget>
  </app-report>
</template>
<script>
import AppReport from '@/components/layouts/AppReport'
import AppWidget from '@/components/AppWidget'
import AppReportHeader from '@/components/AppReportHeader'
import AppLineChart from '@/components/AppLineChart'
import { mapGetters } from 'vuex'
export default {
  components: {
    AppReport,
    AppWidget,
    AppReportHeader,
    AppLineChart
  },
  computed: {
    ...mapGetters(['relatorio', 'cliente', 'openChart', 'tableDense'])
  }
}
</script>
